import ValueFactory from './Factory';

module.exports = {
  ValueFactory
}
